const getFetchOverviewRequestState = (state) => {
  return state.main.analyticsState.fetchOverviewRequestState
}
const getOverview = (state) => {
  return state.main.analyticsState.overview
}
const getFetchAverageDurationRequestState = (state) => {
  return state.main.analyticsState.fetchAverageDurationRequestState
}
const getAverageDuration = (state) => {
  return state.main.analyticsState.averageDuration
}
const getFetchTransactionsStatisticsRequestState = (state) => {
  return state.main.analyticsState.fetchTransactionsStatisticsRequestState
}
const getTransactionsStatistics = (state) => {
  return state.main.analyticsState.transactionsStatistics
}
const getFetchConnectorsStatusRequestState = (state) => {
  return state.main.analyticsState.fetchConnectorsStatusRequestState
}
const getConnectorsStatus = (state) => {
  return state.main.analyticsState.connectorsStatus
}
const getFetchPeakHourRequestState = (state) => {
  return state.main.analyticsState.fetchPeakHourRequestState
}
const getPeakHour = (state) => {
  return state.main.analyticsState.peakHour
}
const getFetchTopSitesRequestState = (state) => {
  return state.main.analyticsState.fetchTopSitesRequestState
}
const getTopSites = (state) => {
  return state.main.analyticsState.topSites
}

const getFetchTokensStatisticsRequestState = (state) => {
  return state.main.analyticsState.fetchTokensStatisticsRequestState
}
const getTokensStatistics = (state) => {
  return state.main.analyticsState.tokensStatistics
}
const getRevenueTrendRequestState = (state) => {
  return state.main.analyticsState.fetchRevenueTrendRequestState
}
const getRevenueTrend = (state) => {
  return state.main.analyticsState.revenueTrend
}
const getTokensActivityRequestState = (state) => {
  return state.main.analyticsState.fetchTokensActivityRequestState
}
const getTokensActivity = (state) => {
  return state.main.analyticsState.tokensActivity
}
const getFetchTopCitiesRequestState = (state) => {
  return state.main.analyticsState.fetchTopCitiesRequestState
}
const getTopCities = (state) => {
  return state.main.analyticsState.topCities
}

const AnalyticsSelectors = {
  getFetchOverviewRequestState,
  getOverview,
  getFetchAverageDurationRequestState,
  getAverageDuration,
  getFetchTransactionsStatisticsRequestState,
  getTransactionsStatistics,
  getFetchConnectorsStatusRequestState,
  getConnectorsStatus,
  getFetchPeakHourRequestState,
  getPeakHour,
  getFetchTopSitesRequestState,
  getTopSites,
  getFetchTokensStatisticsRequestState,
  getTokensStatistics,
  getRevenueTrendRequestState,
  getRevenueTrend,
  getTokensActivityRequestState,
  getTokensActivity,
  getFetchTopCitiesRequestState,
  getTopCities,
}

export default AnalyticsSelectors
